"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Renderables_1 = require("../Renderables");
var node_1 = require("../../support/node");
var Specification_1 = require("../../support/Specification");
/**
 * Implementation of the 'italic' markup element.
 * An i HTML element is created, the attributes id and
 * text from the markup applied and the class
 * lto-italic is added to allow CSS manipulations.
 *
 * @see {@link IRenderable}
 */
var Italic = /** @class */ (function () {
    function Italic(message) {
        this.spec = message;
    }
    /**
     * @inheritDoc
     */
    Italic.prototype.render = function (renderer, isNested) {
        var italic = node_1.default("i");
        new Specification_1.Specification(this.spec).initNode(italic, "lto-italic");
        italic.setAriaLabel(this.spec.ariaLabel);
        return italic.unwrap();
    };
    return Italic;
}());
exports.Italic = Italic;
Renderables_1.default.register("italic", Italic);
